import React, { FC } from "react";
import { Link } from "react-router-dom";
import ImageProject from "../projectsList/img/project.png";
import { useTranslation } from "react-i18next";
import useGetUrlLocale from "../../../hooks/useGetUrlLocale";
import { useUserQuery } from "../../../graphql/menu.hooks";
import { Share, ThreeDots } from "react-bootstrap-icons";
import { Dropdown } from "react-bootstrap";
import PageActions from "./pageActions";
import { UserIcon } from "../../shadedPages/UserIcon/UserIcon";

type ProjectListItemProps = {
  item: any;
  handleShowDeleteModal: (project: any) => void;
  isLastProject: boolean;
};

type Props = {
  handleShowDeleteModal: (project: any) => void;
  projects: any;
};

export const ProjectListTable: FC<Props> = ({
  handleShowDeleteModal,
  projects,
}) => {
  const { t } = useTranslation();

  return (
    <div className="col-12 table-scroll">
      <table className="table table-index mb-0 overflow-hidden rounded">
        <thead>
          <tr className="bg-disabled table-heading">
            <th className="text-dark-gray py-3 ps-4 col-1">
              {t("projects.tablePreview")}
            </th>
            <th className="text-dark-gray py-3 col-3">
              {t("projects.tableTitle")}
            </th>
            <th className="text-dark-gray py-3 col-1">
              {t("projects.tableID")}
            </th>
            <th className="text-dark-gray py-3 col-2">
              {t("projects.tableUsers")}
            </th>
            <th className="text-dark-gray py-3 col-1">
              {t("projects.tableActions")}
            </th>
          </tr>
        </thead>
        <tbody className="bg-white table-content border-white">
          {projects.map((project: any, index: number) => (
            <tr className="align-middle" key={project.id}>
              <ProjectListItemTable
                item={project}
                handleShowDeleteModal={handleShowDeleteModal}
                isLastProject={projects.length === index + 1}
              />
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export const ProjectListItemTable: FC<ProjectListItemProps> = ({
  item,
  handleShowDeleteModal,
  isLastProject,
}) => {
  const lng = useGetUrlLocale();
  const { data: User } = useUserQuery();

  return (
    <>
      <td className="py-3 ps-4">
        <Link
          to={`${lng}/projects/${item.id}`}
          className={`page-prew-table d-flex justify-content-center overflow-hidden border rounded`}
        >
          <img
            className="h-100"
            src={item?.firstPage?.image || ImageProject}
            alt={item.title}
          />
        </Link>
      </td>
      <td>
        <p className="table-title m-0">
          {item.title.length > 20
            ? `${item.title.slice(0, 20)}...`
            : item.title}
        </p>
      </td>
      <td>{item.id}</td>
      <td>
        <div className="d-flex flex-row-reverse justify-content-end">
          {item?.users?.map((user: any) => (
            <UserIcon key={user?.user?.email} email={user?.user?.email} />
          ))}
          <UserIcon email={User?.user?.email} className="user-icon-owner" />
        </div>
      </td>
      <td>
        <div className="d-flex align-items-center actions-bar">
          <div>
            <Link
              to={`${lng}/user/access/domain/${item.id}/access`}
              className="btn btn-outline-primary primary-hover rounded-1 settings-icon text-blue"
            >
              <Share className="fs-6" />
            </Link>
          </div>
          <Dropdown
            drop={isLastProject ? "up" : "down"}
            className="pe-3 mx-3 dropup"
          >
            <Dropdown.Toggle
              variant="outline-primary"
              id="dropdown-basic"
              className="primary-hover"
            >
              <ThreeDots className="fs-6" />
            </Dropdown.Toggle>
            <PageActions
              type={"domain"}
              domainId={item.id}
              deleteDomain={handleShowDeleteModal}
            />
          </Dropdown>
        </div>
      </td>
    </>
  );
};
